<template>
  <div id="question-answer" class="answer-result">
    <h4>{{ answer.resumeText }}</h4>
    <div class="answer-text" v-html="answer.afterTextHtml"></div>
    <div class="next-btn-wrapper">
      <span
          class="next-btn"
          @click.stop="$emit('userClickedNext')"
      >
        {{ answer.button.text }}
      </span>
    </div>
    <div class="answer-img-wrapper">
        <img
            :src="answer.image"
            @load="$emit('answerResultImgHasLoaded')"
        >
    </div>
    <div class="sources-list">
      <div>Источник:</div>
        <p
            v-for="(source, index) in answer.sourcesList"
            :key="index"
            v-html="source"
        ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerResult",
  data: () => ({}),
  props: ['answer'],
  emits: ['userClickedNext', 'answerResultImgHasLoaded']
}
</script>


<style scoped lang="scss">
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 2s ease;
}
.fade-leave {

}
.fade-leave-active {
  transition: opacity 0.5s ease;
  opacity: 0;
}

</style>